var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuggingface(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 246 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_397_2999)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_397_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 115C0 51.4872 51.4873 0 115 0H127C192.722 0 246 53.2781 246 119V127C246 192.722 192.722 246 127 246H123C55.069 246 0 190.931 0 123V115Z",
    fill: "url(#paint0_radial_397_2999)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_397_2999)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 132.5,
    r: 35.5,
    fill: "#FF4242"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_397_2999)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 132.5,
    r: 35.5,
    fill: "#FF4242"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_397_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.54 83.5C106.66 83.5 110.081 80.1218 109.197 76.0978C107.794 69.7112 104.591 63.8008 99.8952 59.1048C93.4252 52.6348 84.65 49 75.5 49C66.35 49 57.5748 52.6348 51.1048 59.1048C46.6509 63.5587 43.5406 69.105 42.0346 75.114C40.8974 79.6519 44.7924 83.5 49.4706 83.5C53.8564 83.5 57.2631 79.7812 59.1273 75.8113C60.0089 73.9338 61.215 72.2045 62.7097 70.7097C66.1019 67.3176 70.7027 65.4118 75.5 65.4118C80.2973 65.4118 84.8981 67.3176 88.2903 70.7097C89.5423 71.9618 90.5918 73.3785 91.4178 74.9089C93.7658 79.2597 97.5961 83.5 102.54 83.5Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.54 83.5C106.66 83.5 110.081 80.1218 109.197 76.0978C107.794 69.7112 104.591 63.8008 99.8952 59.1048C93.4252 52.6348 84.65 49 75.5 49C66.35 49 57.5748 52.6348 51.1048 59.1048C46.6509 63.5587 43.5406 69.105 42.0346 75.114C40.8974 79.6519 44.7924 83.5 49.4706 83.5C53.8564 83.5 57.2631 79.7812 59.1273 75.8113C60.0089 73.9338 61.215 72.2045 62.7097 70.7097C66.1019 67.3176 70.7027 65.4118 75.5 65.4118C80.2973 65.4118 84.8981 67.3176 88.2903 70.7097C89.5423 71.9618 90.5918 73.3785 91.4178 74.9089C93.7658 79.2597 97.5961 83.5 102.54 83.5Z",
    fill: "#221725"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_397_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.54 83.5C203.66 83.5 207.081 80.1218 206.197 76.0978C204.794 69.7112 201.591 63.8008 196.895 59.1048C190.425 52.6348 181.65 49 172.5 49C163.35 49 154.575 52.6348 148.105 59.1048C143.651 63.5587 140.541 69.105 139.035 75.114C137.897 79.6519 141.792 83.5 146.471 83.5C150.856 83.5 154.263 79.7812 156.127 75.8113C157.009 73.9338 158.215 72.2045 159.71 70.7097C163.102 67.3176 167.703 65.4118 172.5 65.4118C177.297 65.4118 181.898 67.3176 185.29 70.7097C186.542 71.9618 187.592 73.3785 188.418 74.9089C190.766 79.2597 194.596 83.5 199.54 83.5Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.54 83.5C203.66 83.5 207.081 80.1218 206.197 76.0978C204.794 69.7112 201.591 63.8008 196.895 59.1048C190.425 52.6348 181.65 49 172.5 49C163.35 49 154.575 52.6348 148.105 59.1048C143.651 63.5587 140.541 69.105 139.035 75.114C137.897 79.6519 141.792 83.5 146.471 83.5C150.856 83.5 154.263 79.7812 156.127 75.8113C157.009 73.9338 158.215 72.2045 159.71 70.7097C163.102 67.3176 167.703 65.4118 172.5 65.4118C177.297 65.4118 181.898 67.3176 185.29 70.7097C186.542 71.9618 187.592 73.3785 188.418 74.9089C190.766 79.2597 194.596 83.5 199.54 83.5Z",
    fill: "#221725"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_diiii_397_2999)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_397_2999",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.462 98.5C185.178 98.5 189.065 102.344 188.359 107.006C187.599 112.026 186.168 116.947 184.09 121.652C180.849 128.993 176.098 135.662 170.108 141.28C164.119 146.898 157.009 151.354 149.183 154.395C141.358 157.435 132.97 159 124.5 159C116.03 159 107.642 157.435 99.8169 154.395C91.9914 151.354 84.881 146.898 78.8916 141.28C72.9022 135.662 68.1512 128.993 64.9098 121.652C62.832 116.947 61.4006 112.026 60.6406 107.006C59.9348 102.344 63.8225 98.5 68.5377 98.5C73.253 98.5 76.9891 102.361 77.9448 106.978C78.5493 109.899 79.4659 112.762 80.6854 115.523C83.0687 120.92 86.562 125.824 90.9658 129.955C95.3695 134.085 100.598 137.362 106.351 139.597C112.105 141.833 118.272 142.983 124.5 142.983C130.728 142.983 136.895 141.833 142.649 139.597C148.402 137.362 153.63 134.085 158.034 129.955C162.438 125.824 165.931 120.92 168.315 115.523C169.534 112.762 170.451 109.899 171.055 106.978C172.011 102.361 175.747 98.5 180.462 98.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.462 98.5C185.178 98.5 189.065 102.344 188.359 107.006C187.599 112.026 186.168 116.947 184.09 121.652C180.849 128.993 176.098 135.662 170.108 141.28C164.119 146.898 157.009 151.354 149.183 154.395C141.358 157.435 132.97 159 124.5 159C116.03 159 107.642 157.435 99.8169 154.395C91.9914 151.354 84.881 146.898 78.8916 141.28C72.9022 135.662 68.1512 128.993 64.9098 121.652C62.832 116.947 61.4006 112.026 60.6406 107.006C59.9348 102.344 63.8225 98.5 68.5377 98.5C73.253 98.5 76.9891 102.361 77.9448 106.978C78.5493 109.899 79.4659 112.762 80.6854 115.523C83.0687 120.92 86.562 125.824 90.9658 129.955C95.3695 134.085 100.598 137.362 106.351 139.597C112.105 141.833 118.272 142.983 124.5 142.983C130.728 142.983 136.895 141.833 142.649 139.597C148.402 137.362 153.63 134.085 158.034 129.955C162.438 125.824 165.931 120.92 168.315 115.523C169.534 112.762 170.451 109.899 171.055 106.978C172.011 102.361 175.747 98.5 180.462 98.5Z",
    stroke: "url(#paint1_linear_397_2999)",
    strokeWidth: 22,
    strokeLinejoin: "round",
    mask: "url(#path-6-inside-1_397_2999)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_397_2999)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_iii_397_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.814 180.191V142.064C69.814 137.551 66.1561 133.894 61.6438 133.894C57.1316 133.894 53.4736 137.551 53.4736 142.064L53.4736 180.191H50.701L47.9479 148.31C47.514 143.285 43.0882 139.563 38.0627 139.997C33.0372 140.431 29.315 144.856 29.749 149.882L32.6097 183.01C31.454 183.771 30.3958 184.669 29.4578 185.679L22.9495 176.4C19.6706 171.726 13.2863 170.683 8.68987 174.07C4.09344 177.458 3.02544 183.994 6.30442 188.669L24.8779 215.148V217.13C24.8779 228.323 32.2613 238.26 43.246 240.407C49.9931 241.726 57.491 242.83 63.6864 242.83C70.668 242.83 79.3036 241.428 86.6549 239.897C96.118 237.925 102.495 229.373 102.495 219.706V203.068C102.495 201.949 102.415 200.849 102.259 199.774L111.793 167.402C113.105 162.947 110.575 158.213 106.143 156.828C101.71 155.443 97.0536 157.931 95.7417 162.386L89.796 182.575C89.1674 182.262 88.5225 181.977 87.8627 181.722L92.8681 148.491C93.5402 144.03 90.468 139.868 86.006 139.195C81.5441 138.523 77.3821 141.596 76.71 146.058L71.5685 180.191H69.814Z",
    fill: "url(#paint2_radial_397_2999)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_397_2999)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_iii_397_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.186 180.191L176.186 142.064C176.186 137.551 179.844 133.894 184.356 133.894C188.868 133.894 192.526 137.551 192.526 142.064L192.526 180.191L195.299 180.191L198.052 148.31C198.486 143.285 202.912 139.563 207.937 139.997C212.963 140.431 216.685 144.856 216.251 149.882L213.39 183.01C214.546 183.771 215.604 184.669 216.542 185.679L223.05 176.4C226.329 171.726 232.714 170.683 237.31 174.07C241.907 177.458 242.975 183.994 239.696 188.669L221.122 215.148L221.122 217.13C221.122 228.323 213.739 238.26 202.754 240.407C196.007 241.726 188.509 242.83 182.314 242.83C175.332 242.83 166.696 241.428 159.345 239.897C149.882 237.925 143.505 229.373 143.505 219.706L143.505 203.068C143.505 201.949 143.585 200.849 143.741 199.774L134.207 167.402C132.895 162.947 135.425 158.213 139.857 156.828C144.29 155.443 148.946 157.931 150.258 162.386L156.204 182.575C156.833 182.262 157.478 181.977 158.137 181.722L153.132 148.491C152.46 144.03 155.532 139.868 159.994 139.195C164.456 138.523 168.618 141.596 169.29 146.058L174.432 180.191L176.186 180.191Z",
    fill: "url(#paint3_radial_397_2999)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_397_2999",
    x: -11,
    y: -24,
    width: 278,
    height: 326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 21,
    dy: 73
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682806 0 0 0 0 0.0652778 0 0 0 0 0.783333 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.943639 0 0 0 0 0.223611 0 0 0 0 0.958333 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_397_2999",
    result: "effect2_innerShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11,
    dy: 30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.766722 0 0 0 0 0.693056 0 0 0 0.68 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_397_2999",
    result: "effect3_innerShadow_397_2999"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_397_2999",
    x: -15,
    y: 58,
    width: 149,
    height: 149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_397_2999"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_397_2999",
    x: 114,
    y: 58,
    width: 149,
    height: 149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_397_2999"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_397_2999",
    x: 41.8353,
    y: 49,
    width: 67.5018,
    height: 34.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26.45,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.2,
    dy: -7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_2999"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_397_2999",
    x: 138.835,
    y: 49,
    width: 67.5018,
    height: 34.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26.45,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.2,
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_2999"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_diiii_397_2999",
    x: 27.2242,
    y: 81.8333,
    width: 194.552,
    height: 127.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.6667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0298758 0 0 0 0 0.0216858 0 0 0 0 0.0308333 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_397_2999",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.18518
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.59259
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.17328 0 0 0 0 0.125777 0 0 0 0 0.178833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.59259
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2963
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.119503 0 0 0 0 0.086743 0 0 0 0 0.123333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_397_2999",
    result: "effect3_innerShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26.45,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_innerShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.2,
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_397_2999",
    result: "effect4_innerShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26.45,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect5_innerShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.2,
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_397_2999",
    result: "effect5_innerShadow_397_2999"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_397_2999",
    x: -1,
    y: 103,
    width: 152,
    height: 152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_397_2999",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_iii_397_2999",
    x: 0.317848,
    y: 124.362,
    width: 118.63,
    height: 122.553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.08511,
    dy: 4.08511
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.46464
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682806 0 0 0 0 0.0652778 0 0 0 0 0.783333 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.7234,
    dy: -9.53191
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.46675
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.943639 0 0 0 0 0.223611 0 0 0 0 0.958333 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_397_2999",
    result: "effect2_innerShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.80851,
    dy: 1.3617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.46675
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_397_2999",
    result: "effect3_innerShadow_397_2999"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_397_2999",
    x: 117,
    y: 103,
    width: 152,
    height: 152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_397_2999",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_iii_397_2999",
    x: 129.775,
    y: 124.362,
    width: 118.63,
    height: 122.553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.08511,
    dy: 4.08511
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.46464
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682806 0 0 0 0 0.0652778 0 0 0 0 0.783333 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.7234,
    dy: -9.53191
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.46675
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.943639 0 0 0 0 0.223611 0 0 0 0 0.958333 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_397_2999",
    result: "effect2_innerShadow_397_2999"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.80851,
    dy: 1.3617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.46675
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_397_2999",
    result: "effect3_innerShadow_397_2999"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_397_2999",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109 16) rotate(86.5167) scale(230.426)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.576389,
    stopColor: "#FFBB0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC907"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_397_2999",
    x1: 124.5,
    y1: 38,
    x2: 124.5,
    y2: 159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B1F2C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_397_2999",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1398 140.979) rotate(86.555) scale(102.035 100.92)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.576389,
    stopColor: "#FFBB0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC907"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_397_2999",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(193.86 140.979) rotate(93.445) scale(102.035 100.92)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.576389,
    stopColor: "#FFBB0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC907"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_397_2999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 246,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuggingface);
export default __webpack_public_path__ + "static/media/huggingface.f8a88bf87977f48906f52cfd970469f8.svg";
export { ForwardRef as ReactComponent };